/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { hasElements } from "utils/arrays";
import ChatContext from "./ChatContext";
import Conversation from "./Conversation";

function Conversations({ onConversationSelected }) {
    const { conversations, selectedConversation } = useContext(ChatContext);
    const [filter, setFilter] = useState("");

    // Focus the active conversation (first in the active-first ordering) on load, in both single
    // and multi mode. Re-selects when the set changes (e.g. after reloading) unless the current
    // selection still belongs to the shown conversations.
    useEffect(() => {
        if (hasElements(conversations)) {
            const stillValid = selectedConversation && conversations.some((c) => c.sid === selectedConversation.sid);
            if (!stillValid) {
                onConversationSelected(conversations[0]);
            }
        }
    }, [conversations]);

    const getConversations = () => {
        const parsedFilter = String(filter).trim().toLowerCase();
        if (parsedFilter) {
            return conversations.filter((x) => String(x.friendlyName).toLowerCase().includes(parsedFilter.toLowerCase()));
        }
        return conversations;
    };

    const onFilterChanged = (event) => setFilter(event.target?.value);
    
    return (
        <section className="conversations">
            <div className="search">
                <input type="text" value={filter} onChange={onFilterChanged} placeholder="Search..." />
            </div>
            <div className="items">
                {hasElements(conversations) &&
                    getConversations().map((conversation) => (
                        <Conversation
                            key={conversation.sid}
                            conversation={conversation}
                            onClick={() => onConversationSelected(conversation)}
                            isSelected={conversation.sid === selectedConversation?.sid}
                        />
                    ))}
            </div>
        </section>
    );
}

export default Conversations;
